import toast from "react-hot-toast";
import { BankDetails } from "../models/epcCustomer.model";

export interface CommissionPDFData {
  customerName: string;
  commissionId: string;
  commissionAmount: number;
  calculatedCommission: number;
  customCommission?: number;
  plantSize: string;
  confirmAt: string | undefined;
  status: string;
  excessAmount?: number;
  commissionValue?: number;
  adjustmentAmount?: number;
}

export const validateBankDetails = (bankDetails: BankDetails): boolean => {
  const { bankAccountName, bankAccountNumber, ifsc } = bankDetails;

  if (!bankAccountName || !bankAccountNumber || !ifsc) {
    toast.error(
      `Missing bank details for PDF generation. Required: 
      ${!bankAccountName ? "Bank Account Name, " : ""}
      ${!bankAccountNumber ? "Bank Account Number, " : ""}
      ${!ifsc ? "IFSC Code" : ""}`,
    );
    return false;
  }

  return true;
};

// Numbers to Words conversion for Indian Rupees

export const numberToWordsINR = (
  amount: number,
  options?: {
    prefix?: string; // "Rupees"
    suffix?: string; // "Only"
  },
): string => {
  if (!Number.isFinite(amount) || amount <= 0) {
    return `${options?.prefix ?? ""} Zero ${options?.suffix ?? ""}`.trim();
  }

  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const inWords = (num: number): string => {
    num = Math.floor(num);

    if (num < 20) return a[num];

    if (num < 100)
      return b[Math.floor(num / 10)] + (num % 10 ? " " + a[num % 10] : "");

    if (num < 1000)
      return (
        a[Math.floor(num / 100)] +
        " Hundred" +
        (num % 100 ? " " + inWords(num % 100) : "")
      );

    if (num < 100000)
      return (
        inWords(Math.floor(num / 1000)) +
        " Thousand" +
        (num % 1000 ? " " + inWords(num % 1000) : "")
      );

    if (num < 10000000)
      return (
        inWords(Math.floor(num / 100000)) +
        " Lakh" +
        (num % 100000 ? " " + inWords(num % 100000) : "")
      );

    return (
      inWords(Math.floor(num / 10000000)) +
      " Crore" +
      (num % 10000000 ? " " + inWords(num % 10000000) : "")
    );
  };

  const words = inWords(amount);

  return `${options?.prefix ?? ""} ${words} ${options?.suffix ?? ""}`.trim();
};
